import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { AsisstantResponse } from 'types/assistant';

export const chatRequest = async (message: string): Promise<AsisstantResponse> => {
  const response: AxiosResponse<AsisstantResponse> = await getApi().get(`AiAssistant/Chat`, {
    params: {
      message,
    },
  });
  return response.data;
};

export const followUpRequest = async (props: { threadId: string; message: string }): Promise<AsisstantResponse> => {
  const { threadId, message } = props;
  const response: AxiosResponse<AsisstantResponse> = await getApi().get(`AiAssistant/FollowUpChat`, {
    params: {
      threadId,
      message,
    },
  });
  return response.data;
};
